"use client";
import React from "react";

const OrgChart = () => {
  return (
    <>
    
     <div  style={{ display: "flex", justifyContent: "center", padding: "20px", height:"100vh",width:"100%" }}>
      <iframe
        style={{ border: "none", borderRadius: "12px" }}
        width="1000"
        height="600"
        src="https://www.figma.com/embed?embed_host=share&url=https://www.figma.com/design/L5YeuCimRbBBFV2UFVfdpY/Vigilance-org-chart?node-id=0-1&t=U9CTjksrcJoYIUGQ-0"
        allowFullScreen
      ></iframe>
    </div>
    </>
   
  );
};

export default OrgChart;
